<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-8 offset-md-2" >            
            <div class="row no-gutters" >
                <h2 class="h2"  > Merge leads </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form class="atlass-form col-12" >
                    <div class="row">

                        <div class="col-12 form-group" >
                            <label for="NameInput" > IP: </label>
                            <b-form-input id="NameInput" 
                            type="text"
                            v-model="IP"
                            required

                            placeholder="IP">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" v-if="IP != null" >
                            <b-button @click="submit()" variant="success" class="btn-sm-w" >Import</b-button>
                        </div>

                    </div>
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'importEvents',
    props: {
        data: { 
            type: [String, Object],
        }
        
    },
    data: function(){
        return {
            loaded: false,
            ID:null,
            IP: null
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        //this.$store.dispatch(PROFILE_REQUEST);
        
    },
    mounted(){
        this.loaded = true
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        
        submit(){
            
            if( this.IP != null || this.IP != "" ){
                this.$parent.$parent.importEvents( this.IP )
            }
            

            
        },
        


    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/importEvents.vue